(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/login/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/login/constants.js');

const FORMS = {
  HEADER: 'Inloggning',
  EMAIL: {
    EMAIL_LABEL: 'E-postadress',
    EMAIL_MAX: 100,
    EMAIL_REQUIRED_ERROR: 'Du måste ange en e-postadress',
    EMAIL_NAME: 'email'
  },
  PASSWORD: {
    PASSWORD_LABEL: 'Lösenord',
    PASSWORD_REQUIRED_ERROR: 'Du måste ange ditt lösenord',
    PASSWORD_NAME: 'password'
  },
  LOGIN_BUTTON_LABEL: 'Logga in',
  PASSWORD_LINK: 'Glömt inloggningsuppgifter?'
};
svs.ticket_partner.login.constants = {
  FORMS
};


 })(window);